import React, { Component } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import nl2br from 'react-nl2br';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from 'reactstrap';
import ContactForm from '../../forms/ContactUs';

const Title = styled.h1`
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 0.25rem;
`;

const SubTitle = styled.h4`
  text-align: center;
  margin-top: 0px;
  margin-bottom: 1.75rem;
  font-size: 1.25rem;
`;

class ContactUs extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  state = {
    isLoading: false,
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }

  onSubmit = (values) => {
    this.setState({ isLoading: true });
    axios.post('https://us-central1-oakhouse-matsuri.cloudfunctions.net/api/contact-us', {
      ...values,
    }).then(() => {
      this.setState({ isLoading: false });
      toast.success(<FormattedMessage id="ContactUs.Submit.Success" />);
    }).catch((err) => {
      console.error(err);
      this.setState({ isLoading: false });
      toast.danger(<FormattedMessage id="ContactUs.Submit.Failure" />);
    });
  }

  render() {
    const { isLoading } = this.state;
    const { intl } = this.props;

    return (
      <Container>
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <Title>
              <FormattedMessage id="ContactUs.Title" />
            </Title>
            <SubTitle>
              {nl2br(intl.formatMessage({
                id: 'ContactUs.SubTitle',
              }))}
            </SubTitle>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <Card style={{ backgroundColor: '#f9f6f6' }}>
              <CardBody>
                <ContactForm
                  onSubmit={this.onSubmit}
                  isLoading={isLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default injectIntl(ContactUs);
